import useList from '../_basic/list';
import useItem from '../_basic/item';
import gqlItem from './item.graphql';
import gqlList from './list.graphql';

const media = new useItem(gqlItem);
const medias = new useList(gqlList);

export default function() {
  return {
    media,
    medias
  };
}
